import store from 'store'
import { generateUserId } from '../helper/session-id'

export const userIdKey = 'perspective__user__id'

export const handleAnonId = () => {
  let storageUserId = getUserId()

  if (!storageUserId) {
    storageUserId = generateUserId()
    setUserId(storageUserId)
  }

  if (typeof window !== `undefined`) {
    if (window.analytics && window.analytics.user) {
      window.analytics.user().anonymousId(storageUserId)
    }
  }
}

export const getUserId = () => {
  return store.get(userIdKey)
}

export const setUserId = (userId) => {
  return store.set(userIdKey, userId)
}

export const setCampaignCookieAccepted = (campaignId) => {
  store.set(`Accept_Cookies_${campaignId}`, 'true')
}

export const getCampaignCookieAccepted = (campaignId) => {
  return store.get(`Accept_Cookies_${campaignId}`)
}

export const setCampaignCookieShow = (campaignId) => {
  store.set(`Show_Cookie_Info_${campaignId}`, 'true')
}
export const getCampaignCookieShow = (campaignId) => {
  return store.get(`Show_Cookie_Info_${campaignId}`)
}
